import VueI18n from 'vue-i18n';
import Vue from 'vue';
import en from '@/translations/en.json';
import nb from '@/translations/nb.json';

Vue.use(VueI18n);

export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'nb'];

const i18n = new VueI18n({
  messages: {
    en,
    nb
  },
  locale: DEFAULT_LOCALE,
  // A key missing from nb.json renders the English text instead of the raw key path.
  fallbackLocale: DEFAULT_LOCALE,
  silentFallbackWarn: true,
  localeDir: '@/translations',
  enableInSFC: true
});

// BCP 47 tag for Intl / toLocale*String() calls, following the active (event) language.
const intlTagByLocale = {
  en: 'en-US',
  nb: 'nb-NO'
};

export function intlLocale() {
  return intlTagByLocale[i18n.locale] || intlTagByLocale[DEFAULT_LOCALE];
}

export default i18n;
